import { Timezone } from '../types/user';

export function timezoneAdapter({ offset_seconds = 0, ...timezone }): Timezone {
  return {
    offsetSeconds: offset_seconds,
    ...timezone,
  } as Timezone;
}
